// Sidebar entries owned by the WorkDay module. The shell places them: see
// src/app/nav.tsx and src/modules/README.md.
import { SidebarType } from '@/types/shared'
import { resources, scopes } from '@/utils/permission'
import { workDayPaths } from './paths'

export const workDayNav = {
    manage: {
        title: 'workday:sidebar_title',
        path: workDayPaths.workdayManage,
        rsname: resources.workday,
        require_scopes: [scopes.index],
        visible_permission_denied: false,
    },
    account: {
        title: 'workday-account-list',
        path: workDayPaths.workdayList,
    },
} satisfies Record<string, SidebarType>
